var map = {
	"./001-working.svg": "f5f5",
	"./002-cloudy.svg": "9a78",
	"./003-wallet.svg": "eb39",
	"./004-vitamins.svg": "f856c",
	"./005-gamepad.svg": "25b2",
	"./006-underpants.svg": "4807",
	"./007-umbrella.svg": "38fc",
	"./008-shirt.svg": "c8b7",
	"./009-garbage.svg": "75e7",
	"./010-toothbrush.svg": "b27b",
	"./011-toilet-paper.svg": "2cc2",
	"./012-toaster.svg": "9832",
	"./013-watch.svg": "1ddc",
	"./014-tie.svg": "c828",
	"./015-ticket.svg": "065c",
	"./016-like.svg": "1344",
	"./017-tablet.svg": "b595",
	"./018-study.svg": "5561",
	"./019-dumbbell.svg": "804b",
	"./020-chat.svg": "8569",
	"./021-sock.svg": "d1c2",
	"./022-slippers.svg": "4c44",
	"./023-sleep.svg": "32e0",
	"./024-shopping-cart.svg": "f4bc",
	"./025-shopping-bag.svg": "c20c",
	"./026-sewing.svg": "73e0",
	"./027-schedule.svg": "9195",
	"./028-repair.svg": "87df",
	"./029-list.svg": "7e42",
	"./030-pillow.svg": "758d",
	"./031-activity.svg": "f1ed",
	"./032-pet.svg": "a0f4",
	"./033-agenda.svg": "1bf9",
	"./034-newspaper.svg": "a4d4",
	"./035-smartphone.svg": "5b2f",
	"./036-mailbox.svg": "e067",
	"./037-laundry-1.svg": "068f",
	"./038-key.svg": "058a1",
	"./039-ironing.svg": "e0cd",
	"./040-invoice.svg": "aae5",
	"./041-hurry.svg": "0713",
	"./042-house.svg": "80699",
	"./043-meat.svg": "263e",
	"./044-eat.svg": "1e33",
	"./045-profits.svg": "999d",
	"./046-wash.svg": "1685",
	"./047-laundry.svg": "0999",
	"./048-cosmetics.svg": "fa6c",
	"./049-cooking.svg": "5d76",
	"./050-coffee.svg": "2e91",
	"./051-cleaning.svg": "ab22",
	"./052-fatherhood.svg": "da6a",
	"./053-car.svg": "872c",
	"./054-calendar.svg": "6274",
	"./055-burger.svg": "9280",
	"./056-briefcase.svg": "44c4",
	"./057-box.svg": "93b4",
	"./058-bathtub.svg": "5b59",
	"./059-handbag.svg": "4bab",
	"./060-alarm-clock.svg": "4641"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0218";